module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/lodash/entries.js
// module id = 1038
// module chunks = 1